import { render, staticRenderFns } from "./listOfProducts.vue?vue&type=template&id=0f525940&"
import script from "./listOfProducts.vue?vue&type=script&lang=js&"
export * from "./listOfProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports